import { faLessThanEqual } from "@fortawesome/free-solid-svg-icons"
import { useEffect, useState } from "react"
import { Modal } from "react-bootstrap"
import { editProductPrice } from "../../../api/requestAxios/activePackage"
import { CommaSeparator, toEnglishNumber, ToPersianNumber } from "../../../functions"
import CustomValuesHook from "../../../functions/myHooks/CustomValuesHook"
import { ErrorToast, InfoToast } from "../../../shared"
import btnClose from "../../../assets/images/svg/close_modal_icon.svg";
import '../style.scss'


const EditPricePackage = ({
    show,
    setShow,
    item,
    handelGetData,
    pageNumber
}) => {

    const [editPackage, setEditPackage] = CustomValuesHook({
        Id: item?.productId,
        MonthlyCharge: item?.monthlyCharge,
        ExtraMinuteCost: item?.extraMinuteCost,
        loading: false

    })

    const [argsTable, setArgsTable] = useState({
        disablePaging: false,
        filterList: [],
        pageSize:30,
        pageNumber: pageNumber,
        whereConditionText: ""
    })



    const handleClose = () => {
        setShow({ showDetails: false })
    }

    const edit = async () => {
        setEditPackage({ loading: true })
        try {
            setEditPackage({ loading: false })

            let temp = editPackage
            temp.MonthlyCharge = editNumberForAPi( temp?.MonthlyCharge)
            temp.ExtraMinuteCost =editNumberForAPi(temp?.ExtraMinuteCost)
            delete temp?.loading


            let result = await editProductPrice(temp)
            InfoToast('تغییر قیمت با موفقیت انجام شد')
            handelGetData(argsTable)
            setShow({ showDetails: false })

        }
        catch (err) {
            setEditPackage({ loading: false })
            ErrorToast(err)
        }
    }

    const editPrice = (e) => {
        e.preventDefault()
        edit()

    }

    const editNumber = (value) => {
        return value !== 0 ? ToPersianNumber(CommaSeparator((Number(toEnglishNumber(value)?.replace(/\,/g, ''))))) : ToPersianNumber(value)
    }

    const editNumberForAPi=(value)=>{
      return  value !== 0 ? Number(toEnglishNumber(value)?.replace(/\,/g, '')) : parseInt(value)
    }


    return (
        <Modal show={show} onHide={handleClose} animation={true} dir="rtl" className="invoice-modal price-modal">
            <Modal.Header>
                <Modal.Title className="d-flex justify-content-between w-100" style={{ fontSize: '16px' }}>
                    ویرایش بسته
                    <img
                        onClick={handleClose}
                        src={btnClose}

                    />
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className='invoice-modal-content-view'>
                <div >
                    <div className="d-flex justify-content-center">
                        <span className="name-product">({item?.productName})</span>
                    </div>
                    <br />
                    <div>
                        <label>قیمت ماهانه:</label>
                        <input
                            type="text"
                            value={editNumber(editPackage?.MonthlyCharge)}
                            onChange={(e) => { setEditPackage({ MonthlyCharge: editNumber(e.target.value) }) }}
                        />
                    </div>
                    <br />
                    <div>
                        <label>قیمت دقیقه:</label>
                        <input
                            type="text"
                            value={editNumber(editPackage?.ExtraMinuteCost)}
                            onChange={(e) => { setEditPackage({ ExtraMinuteCost: editNumber(e.target.value) }) }}
                        />
                    </div>
                    <br />
                    <br />
                    <div className="d-flex justify-content-center">
                        <button
                            disabled={editPackage?.loading}
                            className="btn btn-success btn-add-price"
                            onClick={(e) => { editPrice(e) }}
                        >
                            ذخیره
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default EditPricePackage